import React from 'react'
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";

const TenantHeading = ({heading}) => {
    const history = useHistory();

  return (
    <BlockHead size="sm">
    <BlockBetween>
        <BlockHeadContent>
            <BlockTitle tag="h3" page>
                Add Tenant Detail
            </BlockTitle>
        </BlockHeadContent>
        <BlockHeadContent>
            <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                onClick={() => history.goBack()}
            >
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
            </Button>
            <a
                href="#back"
                onClick={(ev) => {
                    ev.preventDefault();
                    history.goBack();
                }}
                className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
            >
                <Icon name="arrow-left"></Icon>
            </a>
        </BlockHeadContent>
    </BlockBetween>
</BlockHead>
  )
}

export default TenantHeading